import { createSelector } from 'reselect'
import { getIdHeaderBannerSelect } from 'modules/headerBanner/selectors/getId/index.js'

export const hasHeaderBannerSelect = createSelector(
  getIdHeaderBannerSelect,
  id => !!id
)
